import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import classNames from "classnames";
import Select from "react-select";
import { Select2Data } from "../../../utils/common";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
const DeliverySection = ({
  nestIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
  data,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `weeks.${nestIndex}.deliveries`, // The name for nested deliveries
  });

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllProducts = async (id) => {
    const response = await getData(`/common/masters/product/${id}`);
    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllProducts(data?.p_category?.id);
  }, [data]);
  return (
    <div>
      {fields.map((item, deliveryIndex) => (
        <div key={item.id} className="mb-3">
          <Row className="">
            {/* <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Category</Form.Label>
                  <Form.Group>
                    <Controller
                      name={`weeks.${nestIndex}.deliveries.${deliveryIndex}.category_id`} // name of the field
                      {...register(
                        `weeks.${nestIndex}.deliveries.${deliveryIndex}.category_id`,
                        {
                          required: "Select Add On",
                        }
                      )}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.weeks?.[nestIndex]
                                ?.deliveries?.[deliveryIndex]?.category_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={categories}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            getAllProducts(selectedOption.value);
                            setValue(
                              `weeks.${nestIndex}.deliveries.${deliveryIndex}.category_id`,
                              selectedOption
                            );
                            setValue(
                              `weeks.${nestIndex}.deliveries.${deliveryIndex}.product_id`,
                              null
                            );
                          }}
                        />
                      )}
                    />
                    {errors?.weeks?.[nestIndex]?.deliveries?.[deliveryIndex]
                      ?.category_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.category_id.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

            <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Product</Form.Label>
                  <Form.Group>
                    <Controller
                      name={`weeks.${nestIndex}.deliveries.${deliveryIndex}.product_id`} // name of the field
                      {...register(
                        `weeks.${nestIndex}.deliveries.${deliveryIndex}.product_id`,
                        {
                          required: "Select product",
                        }
                      )}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.weeks?.[nestIndex]
                                ?.deliveries?.[deliveryIndex]?.product_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={products}
                          //    onChange={(selectedOption) => {
                          //     field.onChange(selectedOption.value); // Update Controller's value
                          //     getAllProducts(selectedOption.value);
                          //     setValue(`weeks.${nestIndex}.deliveries.${deliveryIndex}.category_id`, selectedOption);
                          //     setValue(`weeks.${nestIndex}.deliveries.${deliveryIndex}.product_id`, null);
                          //   }}
                        />
                      )}
                    />
                    {errors?.weeks?.[nestIndex]?.deliveries?.[deliveryIndex]
                      ?.product_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.product_id.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Quantity</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`weeks.${nestIndex}.deliveries.${deliveryIndex}.quantity`} // Register color for the variant
                      placeholder="Variant Price"
                      className={classNames("", {
                        "is-invalid":
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.quantity,
                      })}
                      {...register(
                        `weeks.${nestIndex}.deliveries.${deliveryIndex}.quantity`,
                        {
                          required: "Quantity is required",
                        }
                      )}
                      onKeyDown={(e) => {
                        // Allow backspace, left and right arrow keys
                        if (
                          e.key === "Backspace" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return; // Allow the action to continue
                        }

                        // Allow digits and decimal point
                        if (!/[\d.]/.test(e.key)) {
                          e.preventDefault(); // Block the invalid key
                        }

                        // Prevent multiple decimal points
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault(); // Block adding another decimal point
                        }
                      }}
                    />
                    {errors?.weeks?.[nestIndex]?.deliveries?.[deliveryIndex]
                      ?.quantity && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.quantity.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
            <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Serving Size</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`weeks.${nestIndex}.deliveries.${deliveryIndex}.serving_size`} // Register color for the variant
                      placeholder="Variant Price"
                      className={classNames("", {
                        "is-invalid":
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.quantity,
                      })}
                      {...register(
                        `weeks.${nestIndex}.deliveries.${deliveryIndex}.serving_size`,
                        {
                          required: "Serving Size is required",
                        }
                      )}
                      onKeyDown={(e) => {
                        // Allow backspace, left and right arrow keys
                        if (
                          e.key === "Backspace" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return; // Allow the action to continue
                        }

                        // Allow digits and decimal point
                        if (!/[\d.]/.test(e.key)) {
                          e.preventDefault(); // Block the invalid key
                        }

                        // Prevent multiple decimal points
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault(); // Block adding another decimal point
                        }
                      }}
                    />
                    {errors?.weeks?.[nestIndex]?.deliveries?.[deliveryIndex]
                      ?.serving_size && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.serving_size.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
            <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Calories</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`weeks.${nestIndex}.deliveries.${deliveryIndex}.calories`} // Register color for the variant
                      placeholder="calories"
                      className={classNames("", {
                        "is-invalid":
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.calories,
                      })}
                      {...register(
                        `weeks.${nestIndex}.deliveries.${deliveryIndex}.calories`,
                        {
                          required: "calories is required",
                        }
                      )}
                      onKeyDown={(e) => {
                        // Allow backspace, left and right arrow keys
                        if (
                          e.key === "Backspace" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return; // Allow the action to continue
                        }

                        // Allow digits and decimal point
                        if (!/[\d.]/.test(e.key)) {
                          e.preventDefault(); // Block the invalid key
                        }

                        // Prevent multiple decimal points
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault(); // Block adding another decimal point
                        }
                      }}
                    />
                    {errors?.weeks?.[nestIndex]?.deliveries?.[deliveryIndex]
                      ?.calories && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {
                          errors?.weeks?.[nestIndex]?.deliveries?.[
                            deliveryIndex
                          ]?.calories.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
          </Row>

          <button type="button" className="add-varient mt-3 mx-2" onClick={() => remove(deliveryIndex)}>
            Remove Delivery
          </button>

          
        </div>
      ))}
      <button type="button" className="add-varient  mt-3 mx-2" onClick={() => append({ duration: "", price: "" })}>
        + Add Delivery
      </button>

      
    </div>
  );
};

export default DeliverySection;
